import React from 'react'
import { Box, Typography, styled } from '@mui/material'

interface Props {
  onClick?: () => void
  onKeyUp?: (e: React.KeyboardEvent<HTMLDivElement>) => void
}

const SkipLink: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
  onKeyUp,
  children,
}) => {
  const handleFocus = (e: React.FocusEvent<HTMLDivElement>) => {
    e.currentTarget.style.opacity = '100%'
    e.currentTarget.style.zIndex = '9999'
  }

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    e.currentTarget.style.opacity = '0%'
    e.currentTarget.style.zIndex = '-9999'
  }

  return (
    <StyledLinkItem
      tabIndex={0}
      component="li"
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={onClick}
      onKeyUp={onKeyUp}
    >
      <Typography variant="h4" component="a" sx={{ color: 'white' }}>
        {children}
      </Typography>
    </StyledLinkItem>
  )
}

const StyledLinkItem = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  background: theme.palette.teal[700],
  color: 'white',
  padding: '10px',
  opacity: '0%',
  zIndex: -9999,
  textDecoration: 'none',
  userSelect: 'none',
  cursor: 'pointer',
  listStyle: 'none',

  [theme.breakpoints.down('mobile')]: {
    fontSize: '1.0rem',
  },
}))

export default SkipLink
